import type {Component} from 'typings/portaro.fe.types';


export interface KpPreformattedTextComponentBindings {
    value: string;
}

export class KpPreformattedTextComponent implements Component<KpPreformattedTextComponentBindings> {
    public static componentName = 'kpPreformattedText';

    public bindings = {
        value: '<'
    } as const;
    public controller = KpPreformattedTextComponentController;
    public templateUrl = require('./kp-preformatted-text.tpl.pug');
    public styleUrls = [require('./kp-preformatted-text.less')]
}

class KpPreformattedTextComponentController implements KpPreformattedTextComponentBindings{
    value: string;
}